// extracted by mini-css-extract-plugin
export default {"container":"ConfirmationModal_container__nxkTo","title":"ConfirmationModal_title__P6vWl","description":"ConfirmationModal_description__gpQ3A"};